/**
 * AUTO GENERATED FILE. DO NOT EDIT AS YOUR CHANGES WILL BE LOST. THIS FILE SHOULD NOT BE ADDED TO SOURCE CONTROL.
 */

export const CommonUiI18nLookup = {
  'en.common': 'i18n/en.common.i18n.6c9975a0f850fa0b25005d792d5afb4e.json',
  'en.legend': 'i18n/en.legend.i18n.ebbcce0bc60b943fa6488cf96324f10c.json',
};
